import React from 'react';

const Footer = () => (
  <footer>
    <hr />
    <small>
      <a href="https://www.whoisyuval.com" target="_blank" rel="noopener noreferrer">
        yuval allweil
      </a>
      {new Date().getFullYear()}
    </small>
  </footer>
);

export default Footer;
